export default {
  image: 'Kapsel_3_2.png',
  pdf: '220829_WA-EPS_004_Kapsel3_2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-EPS-004',
    technicalValues: {
      soundReductionIndex: {
        output: '58,8',
        value: 58.8
      },
      heatTransferCoefficient: {
        output: '0,14',
        value: 0.14
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 60-B / K\u208260' ,
        value: 'F-60-B-K260'
      },
      fireResistanceInner: {
        output: 'F 60-B / K\u208260' ,
        value: 'F-60-B-K260'
      }
    },
    name: 'Wandaufbau mit EPS l Aufbau 4',
    construction: {
      composition: [
        {
          output: 'organischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'org-1'
        },
        {
          output: '100 mm Sto-Dämmplatte Top 32',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'pda-100'
        },
        {
          output: '15 + 18 mm Gipsfaserplatten',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-33'
        },
        {
          output: '≥ 60/160',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-160'
        },
        {
          output: '160 mm Steinwolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cirw-160'
        },
        {
          output: '15 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ig-15'
        },
        {
          output: '18 mm Gipsfaserplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'iq-18'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '333,5',
        value: 333.5
      }
    }
  }
}
